import { post } from '@apis/api';
import { defaultSeo } from '@constants/seo';
import { CommonResponse } from '@wconcept/wconcept-common/models/common-response';

const baseURL = process.env.NEXT_PUBLIC_DISPLAY_API_GATEWAY_URL;
const options = {
  headers: {
    'Content-Type': 'application/json; charset=utf-8',
    'DISPLAY-API-KEY': process.env.NEXT_PUBLIC_DISPLAY_API_GATEWAY_KEY || '',
  },
};

const DEFAULT_AIRBRIDGE_SHARE_METADATA = {
  imageUrl: defaultSeo.openGraph?.images?.[0]?.url,
  profileName: defaultSeo.title,
  description: defaultSeo.description,
} as const;

export interface AirbridgeTrackingLinkParams {
  type: 'promotion' | 'event' | 'shortform' | 'profile';
  shareUrl?: string;
  imageUrl?: string;
  profileName?: string;
  description?: string;
}

export type AirbridgeShareType = AirbridgeTrackingLinkParams['type'];
export type AirbridgeShareContext = AirbridgeTrackingLinkParams;

export interface AirbridgeTrackingLinkResponse {
  trackingId?: number;
  trackingUrl?: string;
}

export const requestAirbridgeTrackingLink = async (
  params: AirbridgeTrackingLinkParams
): Promise<AirbridgeTrackingLinkResponse | undefined> => {
  const requestParams = {
    ...params,
    imageUrl:
      params.imageUrl?.trim() || DEFAULT_AIRBRIDGE_SHARE_METADATA.imageUrl,
    profileName:
      params.profileName?.trim() ||
      DEFAULT_AIRBRIDGE_SHARE_METADATA.profileName,
    description:
      params.description?.trim() ||
      DEFAULT_AIRBRIDGE_SHARE_METADATA.description,
  };
  const { data } = await post<CommonResponse<AirbridgeTrackingLinkResponse>>({
    url: `/display/api/airbridge/v1/${requestParams.type}/tracking-link`,
    options: {
      ...options,
      cache: 'no-cache',
    },
    baseUrl: baseURL,
    data: requestParams,
  });
  return data;
};
